/**
 * The assembler's export menu: the room editor's menu one level up. The 2D
 * and 3D files hold the level on screen; in advanced mode the menu adds the
 * JSON of every room on every level to download or copy (editor-core's
 * `assemblyExportMenuJson`, shared with Kai Pro). There is no paste. Unless
 * read-only, the menu ends with Reset room layout, advanced or not.
 */

import {
  assemblyExportMenuJson,
  assemblyExportMenuReset,
  type DescribeAssemblyRoom,
  type ExportFormat,
  useFloorPlanAssemblerState,
} from '@kaiizen/kai-floor-plan-editor-core';
import { ExportMenu } from '../ExportMenu';

interface AssemblyExportMenuProps {
  /** Downloads the level on screen in a 2D plan or 3D model format. */
  onExport: (format: ExportFormat) => void;
  /** What the JSON says about each room after its id; its name when omitted. */
  describeRoom?: DescribeAssemblyRoom;
  /** Adds the whole-plan JSON (download and copy) to the menu. */
  advanced?: boolean;
}

export function AssemblyExportMenu({ onExport, describeRoom, advanced = false }: AssemblyExportMenuProps): React.JSX.Element {
  const floorPlanAssemblerState = useFloorPlanAssemblerState();
  const jsonMenu = assemblyExportMenuJson(floorPlanAssemblerState, describeRoom);
  return <ExportMenu onExport={onExport} jsonMenu={advanced ? jsonMenu : undefined} resetMenu={assemblyExportMenuReset(floorPlanAssemblerState)} />;
}
